import { Link, useLocation, useNavigate } from "react-router-dom";

const tabs = [
  { icon: "ri-dashboard-3-line", label: "대시보드", path: "/dashboard" },
  { icon: "ri-send-plane-line", label: "발송", path: "/dashboard/send" },
  { icon: "ri-history-line", label: "내역", path: "/dashboard/history" },
  { icon: "ri-settings-3-line", label: "설정", path: "/dashboard/settings" },
];

interface Props {
  onOpenMenu?: () => void;
}

export default function MobileBottomNav({ onOpenMenu }: Props) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0d0d1a] border-t border-white/[0.08] safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`flex flex-col items-center justify-center gap-1 flex-1 h-full cursor-pointer transition-colors ${
                isActive
                  ? "text-violet-400"
                  : "text-gray-500 hover:text-gray-300"
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${tab.icon} text-lg`}></i>
              </div>
              <span className="text-[10px] font-medium whitespace-nowrap">{tab.label}</span>
              {isActive && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-6 h-0.5 rounded-full bg-gradient-to-r from-violet-400 to-pink-400"></span>
              )}
            </Link>
          );
        })}

        {/* 더보기 - 슬라이드 메뉴 열기 또는 대시보드로 이동 */}
        <button
          onClick={() => onOpenMenu ? onOpenMenu() : navigate("/dashboard")}
          className="flex flex-col items-center justify-center gap-1 flex-1 h-full cursor-pointer text-gray-500 hover:text-gray-300 transition-colors"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-menu-line text-lg"></i>
          </div>
          <span className="text-[10px] font-medium whitespace-nowrap">더보기</span>
        </button>
      </div>
    </nav>
  );
}